export * from './entermarks.component';
